import React, {
  useEffect,
  useState,
} from 'react';
import {
  TextField, CardContent, FormControlLabel, Switch, Select, MenuItem, FormControl, InputLabel, CardHeader,
} from '@material-ui/core';
import GalleryField from 'components/GeneralCRUDComponent/FormFields/GalleryField/GalleryField';
import SearchFilterDropdown from 'components/SearchFilterComponent/SearchFilterDropdown';
import {
  WidgetInstance,
} from 'mobx-store/stores/customScreens/types';
import {
  NavigationOptions,
} from 'screens/addEditCustomScreen/components/navigationOptions';
import {
  Props,
  imageWidgetType,
  ColorPalette,
  TitleAlignment,
} from './types';
import styles from './styles.module.scss';

const getWidgetParamsFields = (
  widgetType: imageWidgetType | null, focusedWidgetData: WidgetInstance, handleChange: any,
) => {
  const actualWidgetType = focusedWidgetData.params.cardActionType || widgetType;
  if (actualWidgetType === imageWidgetType.EXTERNAL) {
    return (
      <TextField
        value={focusedWidgetData.params.cardActionExternalLink || ''}
        onChange={(event) => handleChange('cardActionExternalLink', event.target.value)}
        autoFocus
        margin="dense"
        id="cardActionExternalLink"
        label="Widget External Link"
        fullWidth
      />
    );
  }

  if (actualWidgetType === imageWidgetType.INTENAL) {
    return (
      <>
        <NavigationOptions
          redirect={focusedWidgetData.params.cardActionRedirect}
          entityId={focusedWidgetData.params.cardActionEntityId}
          handleEntityIdChangeData={(value: string) => handleChange('cardActionRedirect', value) }
          handleRedirectChangeData={(value: string) => handleChange('cardActionEntityId', value) }
        />
        <TextField
          value={focusedWidgetData.params.cardActionParams || ''}
          onChange={(event) => handleChange('cardActionParams', event.target.value)}
          autoFocus
          margin="dense"
          id="cardActionParams"
          label="Widget Params"
          fullWidth
        />
      </>
    );
  }
  if (actualWidgetType === imageWidgetType.STATIC) {
    return (
      <>
        <TextField
          value={focusedWidgetData.params.cardActionStaticTitle || ''}
          onChange={(event) => handleChange('cardActionStaticTitle', event.target.value)}
          autoFocus
          margin="dense"
          id="cardActionStaticTitle"
          label="Widget Static Title"
          fullWidth
        />
        <TextField
          value={focusedWidgetData.params.cardActionStaticDescription || ''}
          onChange={(event) => handleChange('cardActionStaticDescription', event.target.value)}
          autoFocus
          margin="dense"
          id="cardActionStaticDescription"
          label="Widget Static Description"
          fullWidth
        />
      </>
    );
  }
};

const ImageWidgetCard: React.FC<Props> = (props: Props) => {
  const [widgetType, setWidgetType] = useState<imageWidgetType | null>(null);

  // const delay = (ms: number) => new Promise(res => setTimeout(res, ms));

  const handleIsExternalTitleChange = async () => {
    const isExternalTitle = String(props.focusedWidgetData.params.isExternalTitle) === 'true' ;

    if (isExternalTitle) {
      props.handleMultipleChangeData(
        {
          titleColor: '',
          titleAlignment: '',
          isHorizontalCenter: false,
        },
      );
    } else {
      props.handleMultipleChangeData(
        {
          titleColor: props.focusedWidgetData.params.titleColor || ColorPalette.PRIMARY,
          titleAlignment: props.focusedWidgetData.params.titleAlignment || TitleAlignment.CENTER,
          isHorizontalCenter: props.focusedWidgetData.params.isHorizontalCenter || true,
        },
      );
    }
  };

  useEffect(() => {
    handleIsExternalTitleChange();
  }, [props.focusedWidgetData.params.isExternalTitle]);

  useEffect(() => {
    const isExternalTitle = String(props.focusedWidgetData.params.isExternalTitle) === 'true';
    props.handleMultipleChangeData({
      isExternalTitle,
      cardActionType: props.focusedWidgetData.params.cardActionType || imageWidgetType.INTENAL,
    });
  }, [props.focusedWidgetData.widgetInstanceId]);

  useEffect(() => {
    setWidgetType(props.focusedWidgetData.params.cardActionType as imageWidgetType);
  }, [props.focusedWidgetData.params.cardActionType]);

  return (
    (
      <>
        <CardContent>
          <TextField
            value={props.focusedWidgetData.params.title || ''}
            onChange={(event) => props.handleChangeData('title', event.target.value)}
            autoFocus
            margin="dense"
            id="widgetTitle"
            label="Widget Title"
            fullWidth
          />
          <FormControlLabel
            className={styles.formControl}
            control={(
              <Switch
                checked={String(props.focusedWidgetData.params.isExternalTitle) === 'true' }
                onChange={(event) => props.handleChangeData('isExternalTitle', event.target.checked)}
                name="Is External Title"
                color="primary"
              />
            )}
            label="External Title"
          />
          {
            !(String(props.focusedWidgetData.params.isExternalTitle) === 'true') && (
            <>
              <FormControl variant="outlined" className={styles.formControl}>
                <InputLabel>Title Color</InputLabel>
                <Select
                  label="Title Color"
                  onChange={(event) => props.handleChangeData('titleColor', event.target.value)}
                  value={props.focusedWidgetData.params.titleColor || ''}
                >
                  { Object.values(ColorPalette).map((cp) => <MenuItem key={cp} value={cp}>{cp}</MenuItem>) }
                </Select>
              </FormControl>
              <FormControlLabel
                className={styles.formControl}
                control={(
                  <Switch
                    checked={String(props.focusedWidgetData.params.isHorizontalCenter) === 'true' }
                    onChange={(event) => props.handleChangeData('isHorizontalCenter', event.target.checked)}
                    name="Horizontal center"
                    color="primary"
                  />
                )}
                label="Horizontal center"
              />
              <FormControl variant="outlined" className={styles.formControl}>
                <InputLabel>Vertical Title Alignment</InputLabel>
                <Select
                  label="Vertical Title Alignment"
                  onChange={(event) => props.handleChangeData('titleAlignment', event.target.value)}
                  value={props.focusedWidgetData.params.titleAlignment || ''}
                >
                  { Object.values(TitleAlignment).map((ta) => <MenuItem key={ta} value={ta}>{ta}</MenuItem>) }
                </Select>
              </FormControl>
            </>
            )}

          <GalleryField
            errors=""
            touched=""
            filedType="GalleryField"
            onAddImage={(name, image) => {
              props.handleChangeData('imageURL', URL.createObjectURL(image));
            }}
            onRemoveImage={() => {
              props.handleChangeData('imageURL', '');
            }}
            name="widgetImage"
            value={props.focusedWidgetData.params.imageURL ? [{
              imageUrl: props.focusedWidgetData.params.imageURL,
            }] : []}
            accept="image/*"
            size={200}
            label="Widget Image"
            isLimitToOneImage
          />
          <TextField
            value={props.focusedWidgetData.params.descriptionTitle || ''}
            onChange={(event) => props.handleChangeData('descriptionTitle', event.target.value)}
            autoFocus
            margin="dense"
            id="descriptionTitle"
            label="Widget Description Title"
            fullWidth
          />

          <TextField
            value={props.focusedWidgetData.params.descriptionSubTitle || ''}
            onChange={(event) => props.handleChangeData('descriptionSubTitle', event.target.value)}
            autoFocus
            margin="dense"
            id="descriptionSubTitle"
            label="Widget Description Sub Title"
            fullWidth
          />

          <TextField
            value={props.focusedWidgetData.params.descriptionLabel || ''}
            onChange={(event) => props.handleChangeData('descriptionLabel', event.target.value)}
            autoFocus
            margin="dense"
            id="descriptionLabel"
            label="Widget Description Label"
            fullWidth
          />
          <FormControl variant="outlined" className={styles.formControl}>
            <InputLabel>Description label color</InputLabel>
            <Select
              label="Description label color"
              onChange={(event) => props.handleChangeData('descriptionLabelColor', event.target.value)}
              value={props.focusedWidgetData.params.descriptionLabelColor || ''}
            >
              { Object.values(ColorPalette).map((cp) => <MenuItem key={cp} value={cp}>{cp}</MenuItem>) }
            </Select>
          </FormControl>
          <GalleryField
            errors=""
            touched=""
            filedType="GalleryField"
            onAddImage={(name, image) => {
              props.handleChangeData('iconImage', URL.createObjectURL(image));
            }}
            onRemoveImage={() => {
              props.handleChangeData('iconImage', '');
            }}
            name="widgetImage"
            value={props.focusedWidgetData.params.iconImage ? [{
              imageUrl: props.focusedWidgetData.params.iconImage,
            }] : []}
            accept="image/*"
            size={200}
            label="Widget iconImage"
            isLimitToOneImage
          />
          <SearchFilterDropdown
            label="Widget Type"
            searchFilterDropdown={{
              filters: Object.entries(imageWidgetType).map((type) => ({
                value: type[1], name: type[0],
              })),
              value: props.focusedWidgetData.params.cardActionType,
              initialValue: widgetType || '',
              onChange: (status: imageWidgetType) => {
                props.handleChangeData('cardActionType', status);
              },
            }}
          />
          {
            getWidgetParamsFields(widgetType, props.focusedWidgetData, props.handleChangeData)
          }
        </CardContent>
      </>
    )
  );
};

export default ImageWidgetCard;


// Widget type 
// isCarousel force to 24columns 
// widgetWidth 1 - 24
// title
// actionBar hide if is isCarousel
// data [{}] => 

// 1 - widget type 
// 2 - isCarousal : (force element width 24)
// 3 - widgetWidth
// 4 - title
// 5 - see all action
// 6 - data: 